module.exports = __webpack_public_path__ + "static/media/mean-kittah.bac591e1.png";